import React from 'react';
import PropTypes from 'prop-types';

const FontAwesome = (props) => {
  const { icon, style, className } = props;

  return (
    <i className={`${icon[0]} fa-${icon[1]} ${className}`} style={style} />
  );
};

FontAwesome.propTypes = {
  icon: PropTypes.arrayOf(PropTypes.string),
  style: PropTypes.objectOf(PropTypes.string),
  className: PropTypes.string,
};

FontAwesome.defaultProps = {
  icon: [],
  style: {},
  className: '',
};

export default FontAwesome;
